import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "33.674",
  height: "35.039",
  viewBox: "0 0 33.674 35.039"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4222.424,247.593c-1.745.691-3.619,5.345-3.732,13.954l4.583-6.347v-7.8A3.309,3.309,0,0,0,4222.424,247.593Z",
  transform: "translate(-4205.742 -226.507)"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4189.506,153.306c-2.237,7.07-9.435,8.25-9.513,8.261l-.089.007-3.987,0v-1.183h0v-6.6h3.885a3.748,3.748,0,0,1,3.886,3.595.851.851,0,0,1,0,.1,3.367,3.367,0,0,1-.534,1.72,10.575,10.575,0,0,0,5.508-7.312,10.9,10.9,0,0,0-8.855-4.371h-23.013l12.353,5.38v22.442c.828-4.851,2.4-7.243,3.894-7.836a4.628,4.628,0,0,1,1.287-.278v.019h5.479a11.089,11.089,0,0,0,7.335-2.706,9.5,9.5,0,0,0,3.323-7.057c0-.034,0-.066,0-.1A9.205,9.205,0,0,0,4189.506,153.306Z",
  transform: "translate(-4156.789 -147.527)"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}